// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"362":"a600996d89430484","382":"034cc89d4c371df6","603":"94aa007c5119d9ba","621":"57047edab2ed4dad","673":"7a3b82ffb75ef175","809":"fbc4de85300d5c25","894":"2c8c2bc5f4a62ace"}[chunkId] + ".js";
};